import { Button } from './Button.js';
import { Dialog } from './Dialog.js';

export type ConfirmDialogProps = {
  open: boolean;
  title: string;
  /** Name the exact thing being destroyed — never "this item". */
  body: string;
  confirmLabel: string;
  busy?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export function ConfirmDialog(props: ConfirmDialogProps) {
  return (
    <Dialog open={props.open} title={props.title} onClose={props.onClose}>
      <p className="text-ink-muted">{props.body}</p>
      <div className="mt-(--space-5) flex justify-end gap-(--space-2)">
        <Button variant="secondary" onClick={props.onClose} disabled={props.busy === true}>
          Cancel
        </Button>
        <Button variant="danger" onClick={props.onConfirm} disabled={props.busy === true}>
          {props.busy === true ? 'Working…' : props.confirmLabel}
        </Button>
      </div>
    </Dialog>
  );
}
